import api from '../../api'

const reply = (payload, next) => {
    api.post("/trustpilot/reviews/" + payload.query.conversationId +".reply", payload.body, (err, data) => {
        if(err) return next(err, null);
        next(null, data);
    })   
};

const _delete = (payload, next) => {
    api.delete("/social/" + payload.query.reviewId, (err, data) => {
        if(err) return next(err, null);
        next(null, data);
    })   
};

export default {
  api: {
    review: {
      reply,
      delete: _delete,
    }
  }
}


// WEBPACK FOOTER //
// ./src/libs/trustpilot/index.js